<template>
  <div class="flex-grid d-none d-lg-flex">
    <a
      v-for="(offer, index) in store.selectedCard.explore_offers"
      :key="index"
      :href="offer.href"
      class="card bg-white d-flex flex-column custom_click_track"
      target="_blank"
      :custom_click_track_value="trackingAttr(store.selectedCard.tracking_version, 'EXPLORE', offer.tracking_id)"
    >
      <img :src="offer.img_src" :alt="offer.img_alt">
      <div class="copy-wrap d-flex flex-column flex-1-0-auto">
        <div>
          <h4 class="subheading-2" v-html="offer.heading"></h4>
          <p v-html="offer.body"></p>
        </div>
        <div class="mt-auto pt-2">
          <p class="link-arrow">{{ offer.cta_copy }}</p>
        </div>
      </div>
    </a>
  </div>
  <div class="swiper-outer-wrap d-lg-none">
    <swiper
      :modules="[Pagination]"
      :pagination="{ clickable: true }"
      loop
      :space-between="30"
    >
      <swiper-slide v-for="(offer, index) in store.selectedCard.explore_offers" :key="index">
        <a
          :href="offer.href"
          class="card bg-white d-flex flex-column custom_click_track"
          target="_blank"
          :custom_click_track_value="trackingAttr(store.selectedCard.tracking_version, 'EXPLORE', offer.tracking_id)"
        >
          <img :src="offer.img_src" :alt="offer.img_alt">
          <div class="copy-wrap d-flex flex-column flex-1-0-auto">
            <div>
              <h4 class="subheading-2" v-html="offer.heading"></h4>
              <p v-html="offer.body"></p>
            </div>
            <div class="mt-auto pt-2">
              <p class="link-arrow">{{ offer.cta_copy }}</p>
            </div>
          </div>
        </a>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useStore } from '../store';
import { shuffleArray, trackingAttr } from '../utilities';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';

const store = useStore();
const OFFERS_AMOUNT = 3;

onMounted(() => {
  store.content.cards.map(card => {
    const offers = card.explore_offers;
    shuffleArray(offers);
    const spliceStart = OFFERS_AMOUNT;
    const amountToSplice = offers.length - OFFERS_AMOUNT;
    offers.splice(spliceStart, amountToSplice);
  });
});
</script>
